import { isVisible as o, getActiveElement as i, contains as a } from "../__chunks/DTR5TSDJ.js";
import { __spreadValues as c } from "../__chunks/3YLGPPWQ.js";
var n = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function s(t) {
  return !(!t.matches(n) || !o(t) || t.closest("[inert]"));
}
function l(t) {
  for (; t && !s(t); )
    t = t.closest(n);
  return t || null;
}
function b(t) {
  const e = i(t);
  if (!e) return !1;
  if (e === t) return !0;
  const r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id : !1;
}
function u(t) {
  const e = i(t);
  if (!e) return !1;
  if (a(t, e)) return !0;
  const r = e.getAttribute("aria-activedescendant");
  return !r || !("id" in t) ? !1 : r === t.id ? !0 : !!t.querySelector(`#${CSS.escape(r)}`);
}
function v(t) {
  !u(t) && s(t) && t.focus();
}
function h(t, e) {
  "scrollIntoView" in t ? (t.focus({ preventScroll: !0 }), t.scrollIntoView(c({ block: "nearest", inline: "nearest" }, e))) : t.focus();
}
export {
  v as focusIfNeeded,
  h as focusIntoView,
  l as getClosestFocusable,
  b as hasFocus,
  u as hasFocusWithin,
  s as isFocusable
};
//# sourceMappingURL=focus.js.map
